module.exports = __webpack_public_path__ + "static/media/crosslines.c7dcdce1.svg";